module.exports = __webpack_public_path__ + "static/img/8.4969333.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/3/6/zh/8.png
// module id = wwQO
// module chunks = 0